<template>
  <div v-if="visible" class="toast-overlay">
    <div class="toast" :class="type">
      <span class="toast-message">{{ message }}</span>
      <button class="toast-close" @click="close">✕</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    message: String,
    type: {
      type: String,
      default: "error", // error | warning | success
    },
    visible: Boolean,
  },
  emits: ["update:visible"],
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.toast-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
}

.toast {
  min-width: 300px;
  max-width: 400px;
  padding: 16px 20px;
  border-radius: 8px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}
.toast-message{
  white-space: pre-line;
}
/* tipos */
.toast.error { background: #e53935; }
.toast.warning { background: #f9a825; }
.toast.success { background: #43a047; }

.toast-close {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding-left:8px;
}
</style>